import { memo } from 'react'
import { AccordionDetails, Box, Divider } from '@mui/material'
import PropTypes from 'prop-types'

import ItemDrawing from './ItemDrawing'
import ItemPrices from './ItemPrices'
import ItemSecondaryProcesses from './ItemSecondaryProcesses'
import ItemSettings from './ItemSettings'

const classes = {
    AccordionDetailsRoot: {
        display: 'flex',
        backgroundColor: 'background.paper',
        padding: 3,
        borderTop: (theme) => `1px solid ${theme.palette.grey[400]}`,
        containerType: 'inline-size',
        containerName: 'ItemDetails',
        flexDirection: {
            '@0/OrderItem': 'column',
            '@940/OrderItem': 'row',
        },
    },
}

const ItemDetails = ({ isRotary, orderItemId }) => {
    return (
        <AccordionDetails sx={classes.AccordionDetailsRoot}>
            <Box
                sx={{
                    display: 'flex',

                    gap: 3,
                }}
            >
                <ItemDrawing orderItemId={orderItemId} />
                <Divider
                    orientation="vertical"
                    flexItem
                />
                <ItemSettings
                    key={orderItemId}
                    orderItemId={orderItemId}
                />
                <Divider
                    orientation="vertical"
                    sx={{ display: { '@0/OrderItem': 'none', '@940/OrderItem': 'block' }, marginRight: 3 }}
                    flexItem
                />
            </Box>
            <Box
                sx={{
                    alignItems: 'flex-start',
                    display: 'flex',
                    flex: '1 0 auto',
                    flexDirection: 'column',
                    gap: 2,
                    minWidth: '440px',
                    maxWidth: { '@0/OrderItem': '100%' },
                    justifyContent: isRotary ? 'flex-end' : 'flex-start',
                }}
            >
                <Divider
                    orientation="horizontal"
                    sx={{ display: { '@0/OrderItem': 'block', '@940/OrderItem': 'none' }, marginTop: 3 }}
                    flexItem
                />

                <ItemSecondaryProcesses orderItemId={orderItemId} />

                <Divider
                    orientation="horizontal"
                    flexItem
                />
                <ItemPrices orderItemId={orderItemId} />
            </Box>
        </AccordionDetails>
    )
}

ItemDetails.propTypes = {
    isRotary: PropTypes.bool,
    orderItemId: PropTypes.string,
}

export default memo(ItemDetails)
